import { useLocalization } from 'localization/useLocalization';
import React from 'react';

export const NotApplicableEm = () => {
	const strings = useLocalization();
	return <em>{strings.notApplicableAbbreviation}</em>;
};
